export default "__VITE_ASSET__CXEe_8nZ__"